import { TableCell } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledParentHeaderCollapseTableCell = styled(TableCell)({
  width: "48px",
  minWidth: "48px",
  maxWidth: "48px",
  padding: 0,
  background: "#FAFAFF",
  textAlign: "center",
  verticalAlign: "center",
});

export const StyledParentHeaderTableCell = styled(TableCell)({
  width: "25%",
});

export const StyledParentBodyTableCell = styled(TableCell)({
  width: "25%",
});

export const StyledHeaderTableCell = styled(TableCell)({
  width: "10%",
});

export const StyledBodyTableCell = styled(TableCell)({
  width: "10%",
});
